import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, MessageSquareIcon, ShoppingCartIcon, ClipboardCheckIcon, HeartHandshakeIcon } from 'lucide-react';
interface DeliverableProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  index: number;
  isInView: boolean;
}
function DeliverableCard({
  icon,
  title,
  description,
  index,
  isInView
}: DeliverableProps) {
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} animate={isInView ? {
    opacity: 1,
    x: 0
  } : {}} transition={{
    duration: 0.5,
    delay: 0.15 * index
  }} className="flex gap-4 bg-white rounded-xl p-5 shadow-sm shadow-[#3D2B1F]/5 border border-[#E8A838]/10" data-id="element-164">
      <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#FFF3D6] flex items-center justify-center" data-id="element-165">
        {icon}
      </div>
      <div data-id="element-166">
        <h3 className="text-lg font-bold text-[#3D2B1F] mb-1" style={{
        fontFamily: "'DM Serif Display', Georgia, serif"
      }} data-id="element-167">
          {title}
        </h3>
        <p className="text-[#5C4A3A] text-base leading-relaxed" data-id="element-168">
          {description}
        </p>
      </div>
    </motion.div>;
}
export function WhatYouGetSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-[#F5EDE4] px-4 py-16 md:py-24" data-id="element-169">
      <div className="max-w-3xl mx-auto" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-171">
          <span className="inline-block px-3 py-1 text-sm font-semibold text-[#A84A22] bg-[#FFF3D6] rounded-full mb-4" data-id="element-172">
            Acceso Inmediato
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#3D2B1F] leading-tight" data-id="element-173">
            Lo que recibes hoy
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-174">
          <DeliverableCard icon={<BookOpenIcon className="w-6 h-6 text-[#E8A838]" aria-hidden="true" data-id="element-176" />} title="Manual Principal (PDF)" description="La guía paso a paso para manejar crisis emocionales sin gritos ni arrepentimientos." index={0} isInView={isInView} data-id="element-175" />
          <DeliverableCard icon={<MessageSquareIcon className="w-6 h-6 text-[#E8A838]" aria-hidden="true" data-id="element-178" />} title="Mini-Guía de Frases Clave" description="Oraciones exactas para usar en el momento crítico y conectar con tu hijo sin perder la autoridad." index={1} isInView={isInView} data-id="element-177" />
          <DeliverableCard icon={<ShoppingCartIcon className="w-6 h-6 text-[#E8A838]" aria-hidden="true" data-id="element-180" />} title="Protocolo de Supermercado" description="Un plan de 3 pasos para manejar berrinches en público eliminando la vergüenza social." index={2} isInView={isInView} data-id="element-179" />
          <DeliverableCard icon={<ClipboardCheckIcon className="w-6 h-6 text-[#E8A838]" aria-hidden="true" data-id="element-182" />} title="Listas de Verificación (Checklists)" description="Para detectar detonantes antes de que explote la crisis en tu casa." index={3} isInView={isInView} data-id="element-181" />
          <DeliverableCard icon={<HeartHandshakeIcon className="w-6 h-6 text-[#E8A838]" aria-hidden="true" data-id="element-184" />} title="Guía de Reparación" description="Qué decir exactamente después de que tú mismo perdiste el control (porque a veces pasa)." index={4} isInView={isInView} data-id="element-183" />
        </div>
      </div>
    </section>;
}